import script from "./VrpNotificationQueueToast.vue?vue&type=script&setup=true&lang=js"
export * from "./VrpNotificationQueueToast.vue?vue&type=script&setup=true&lang=js"

import "./VrpNotificationQueueToast.vue?vue&type=style&index=0&id=31141fc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31141fc4"]])

export default __exports__